import { useSessionSipActivity } from "./SessionSipActivityContext";

export default function SessionChangedBadge({ item }) {
  const { getActivity } = useSessionSipActivity();
  const activity = getActivity(item);
  if (!activity) return null;
  const time = new Date(activity.changedAt).toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
  return <span className="session-changed-badge" title={`${activity.changedFields.join(", ")} · ${time}`}>Изменено в сессии</span>;
}
